export default {
  nav: {
    coreLogic: 'Logika Inti',
    profitMechanism: 'Mekanisme Profit',
    profitFlywheel: 'Flywheel Profit',
    sysArch: 'Arsitektur Sistem',
    tradingExample: 'Kasus Trading',
    cta: 'Mulai',
    language: 'Bahasa',
  },
  hero: {
    badge: 'Poly Ai Claw Intelligence Engine',
    title1: 'Dari Prediksi ke',
    title2: 'Arbitrase Probabilitas',
    desc: 'Polywin meningkatkan pasar prediksi menjadi mesin arbitrase sistematis melalui Poly Ai Claw Intelligence Engine',
    ctaPrimary: 'Aktifkan Poly Ai Claw Engine',
    ctaSecondary: 'Lihat Demo',
    statsEvents: 'Event Dipantau',
    statsSuccessRate: 'Tingkat Keberhasilan',
    statsExecTime: 'Waktu Eksekusi',
    cardTitle: 'Analisis Deviasi Probabilitas',
    cardBadge: 'Zona Keunggulan EV',
    cardMarketProb: 'Probabilitas Pasar',
    cardAiProb: 'Probabilitas AI',
    cardMarketImplied: 'Probabilitas Implisit Pasar',
    cardAiTrue: 'Probabilitas Sejati AI',
    cardProbDiff: 'Keunggulan Probabilitas',
  },
  coreLogic: {
    badge: 'Sistem Keputusan PolyAi-Claw',
    title1: 'Dari Agregasi Data ke Keuntungan Compound —',
    title2: 'Loop Otomatis Penuh',
    desc: 'Data multi-sumber → AI → Deviasi probabilitas → Eksekusi otomatis → Keuntungan compound',
    step0_title: 'Lapisan Data',
    step0_sub: 'Agregasi Multi-Sumber',
    step0_i0: 'Peristiwa Politik',
    step0_i1: 'Makro Ekonomi',
    step0_i2: 'Sentimen Sosial',
    step0_i3: 'Data Order Book',
    step1_title: 'Pemodelan AI',
    step1_sub: 'Pembaruan Probabilitas Bayes',
    step1_i0: 'Input Data Real-time',
    step1_i1: 'AI Modeling Engine',
    step1_i2: 'Perhitungan Probabilitas',
    step1_i3: 'Optimasi Model',
    step2_title: 'Deteksi Deviasi',
    step2_sub: 'Identifikasi Deviasi Probabilitas',
    step2_i0: 'Probabilitas Implisit Pasar',
    step2_i1: 'Probabilitas Sejati AI',
    step2_i2: 'Identifikasi Keunggulan EV',
    step2_i3: 'Sinyal Posisi',
    step3_title: 'Eksekusi On-chain',
    step3_sub: 'Trading Otomatis Polygon',
    step3_i0: 'Kontrol Risiko',
    step3_i1: 'Alokasi Modal',
    step3_i2: 'Penyelesaian USDC',
    step3_i3: 'Kontrak Pintar',
    step4_title: 'Keuntungan Compound',
    step4_sub: 'Reinvestasi Otomatis',
    step4_i0: 'Penyelesaian Event',
    step4_i1: 'Likuidasi Profit',
    step4_i2: 'Perhitungan Compound',
    step4_i3: 'Loop Reinvestasi',
    keyTitle: 'Tujuan Inti',
    keyDesc: 'Tujuan PolyAi-Claw adalah terus menemukan kesalahan harga probabilitas (Mispricing) di pasar dan melakukan arbitrase sistematis.',
    keyHighlight: 'terus menemukan kesalahan harga probabilitas dan melakukan arbitrase sistematis',
  },
  profitMechanism: {
    badge: 'Mekanisme Profit Inti',
    title1: '3 Mekanisme Profit',
    title2: 'PolyAi-Claw',
    desc: 'Sistem arbitrase probabilitas stabil melalui deteksi keunggulan EV, eksekusi milidetik, dan manajemen modal 3 tingkat',
    m1_title: 'Deteksi Keunggulan EV',
    m1_sub: 'Probability Edge Detection',
    m1_desc: 'Logika inti: Harga pasar ≠ Probabilitas sejati. Ketika AI mendeteksi deviasi, sistem secara otomatis memasuki zona EV dan memicu posisi.',
    m1_marketImplied: 'Probabilitas Implisit Pasar',
    m1_aiTrue: 'Probabilitas Sejati AI',
    m1_probDiff: 'Keunggulan Probabilitas',
    m1_note: 'Prinsip sama dengan arbitrase opsi dana quant',
    m2_title: 'Eksekusi Otomatis Milidetik',
    m2_sub: 'Millisecond Execution',
    m2_desc: 'Kerangka eksekusi otomatis penuh memastikan peluang arbitrase tidak hilang.',
    m2_i0_title: 'Kecepatan Eksekusi Milidetik',
    m2_i0_sub: 'Rata-rata <200ms',
    m2_i1_title: 'Transparan On-chain Penuh',
    m2_i1_sub: 'Polygon PoS',
    m2_i2_title: 'Tanpa Campur Tangan Manusia',
    m2_i2_sub: 'Penyelesaian Otomatis Kontrak Pintar',
    m2_network_label: 'Jaringan Eksekusi',
    m2_network_val: 'Polygon + USDC',
    m3_title: 'Manajemen Modal 3 Tingkat',
    m3_sub: 'Three-Tier Risk Control',
    m3_desc: 'Menghindari leverage tinggi dan risiko titik tunggal dalam spekulasi tradisional.',
    m3_i0_title: 'Pool Keuntungan Stabil',
    m3_i0_desc: 'Arbitrase probabilitas kepastian tinggi, risiko terendah',
    m3_i1_title: 'Pool Arbitrase Volatilitas',
    m3_i1_desc: 'Menangkap volatilitas pasar, elastisitas keuntungan tinggi',
    m3_i2_title: 'Pool Perlindungan Lindung',
    m3_i2_desc: 'Lindung event korelasi rendah, mengurangi risiko sistemik',
    m3_risk: 'Eksposur Per Event < 5%',
    formula_title: 'Rumus Arbitrase Probabilitas',
    formula_marketPrice: 'Harga Pasar',
    formula_aiTrue: 'Probabilitas Sejati AI',
    formula_trigger: 'Picu Posisi',
    formula_arbitrage: 'Arbitrase',
    formula_hiddenPct: 'Implisit 60%',
    formula_evEdge: 'Keunggulan EV +12%',
    formula_autoExec: 'Eksekusi Otomatis',
  },
  fundManagement: {
    riskTitle: 'Prinsip Kontrol Risiko Inti',
    riskDesc: 'Sistem menetapkan eksposur maksimum per event < 5%.',
    riskHighlight: 'eksposur maksimum per event < 5%',
    stat_maxSingle: 'Investasi Maksimum Per Kali',
    stat_maxSingleVal: '5%',
    stat_diversify: 'Diversifikasi Modal',
    stat_diversifyVal: '20+ Event',
    stat_stopLoss: 'Mekanisme Stop-loss',
    stat_stopLossVal: 'Auto-dipicu',
    vizTitle: 'Visualisasi Data Kontrol Risiko',
    viz_exposure: 'Kontrol Eksposur',
    viz_diversify: 'Diversifikasi Modal',
    viz_correlation: 'Korelasi Event',
    viz_stability: 'Stabilitas Strategi',
  },
  techAdvantage: {
    badge: 'Keunggulan Inti',
    title1: 'Mengapa PolyAi-Claw',
    title2: 'Lebih Unggul dari Pasar Prediksi Tradisional?',
    dim_decision: 'Dasar Keputusan',
    dim_monitor: 'Frekuensi Pemantauan',
    dim_execute: 'Metode Eksekusi',
    dim_model: 'Model Kognitif',
    dim_risk: 'Kontrol Risiko',
    human_decision: 'Didorong Emosi',
    human_monitor: 'Frekuensi Rendah',
    human_execute: 'Order Manual',
    human_model: 'Subjektif',
    human_risk: 'Berbasis Pengalaman',
    ai_decision: 'Didorong Data',
    ai_monitor: 'Frekuensi Tinggi',
    ai_execute: 'Eksekusi Otomatis',
    ai_model: 'Model Probabilitas',
    ai_risk: 'Dikelola Algoritma',
    humanPredict: 'Prediksi Manusia',
    adv1_title: 'Data vs Emosi',
    adv1_desc: 'PolyAi-Claw memodelkan berdasarkan data multi-sumber termasuk peristiwa politik, ekonomi makro, sentimen sosial.',
    adv1_label: 'Jumlah Sumber Data',
    adv2_title: 'Frekuensi Tinggi vs Rendah',
    adv2_desc: 'Sistem memantau 24/7 tanpa henti, mengidentifikasi peluang deviasi probabilitas secara real-time.',
    adv2_label: 'Frekuensi Pemantauan',
    adv3_title: 'Otomatis vs Manual',
    adv3_desc: 'Eksekusi otomatis milidetik melalui kontrak pintar di Polygon, tanpa campur tangan manusia.',
    adv3_label: 'Kecepatan Eksekusi',
    adv4_title: 'Algoritma vs Pengalaman',
    adv4_desc: 'Sistem manajemen modal 3 tingkat dengan eksposur per event di bawah 5%.',
    adv4_label: 'Kontrol Risiko',
    conclusion_title: 'Dari Pasar Prediksi ke Poly Ai Claw Intelligence Engine',
    conclusion_desc1: 'Ini meningkatkan PolyWin dari Prediction Market sederhana menjadi',
    conclusion_brand: 'Poly Ai Claw Intelligence Engine',
    conclusion_desc2: 'Sistem Prediksi Kuantitatif Poly Ai Claw',
  },
  productNarrative: {
    badge: 'Positioning Produk',
    title: 'Identitas Sejati PolyWin',
    desc: 'PolyWin bukan sekadar pasar prediksi, melainkan sistem terintegrasi yang menggabungkan AI, pasar prediksi, OpenClaw, dan trading kuantitatif.',
    item0_title: 'Sistem Arbitrase Probabilitas',
    item0_sub: 'Terus menangkap kesalahan harga pasar',
    item1_title: 'Model Eksekusi Disiplin',
    item1_sub: 'Otomatis, tanpa campur tangan emosi',
    item2_title: 'AI Risk Management Engine',
    item2_sub: 'Kontrol risiko cerdas',
    visual_title: '3 Ekspresi Visual',
    vis0_title: '① Grafik Deviasi Kurva Probabilitas',
    vis0_desc: 'Menampilkan kurva probabilitas AI vs kurva harga pasar',
    vis0_ai: 'Probabilitas AI',
    vis0_market: 'Harga Pasar',
    vis0_diff: 'Perbedaan',
    vis1_title: '② Grafik Radar Kontrol Risiko',
    vis1_desc: 'Menampilkan eksposur risiko, diversifikasi modal, korelasi event, stabilitas strategi',
    vis1_exposure: 'Eksposur Risiko',
    vis1_diversify: 'Diversifikasi Modal',
    vis1_safe: 'Zona Aman',
    vis1_safeVal: 'Masuk',
    vis2_title: '③ Diagram Alur Trading Otomatis AI',
    vis2_desc: 'Menyoroti loop lengkap: Data → AI → Eksekusi → Likuidasi → Compound',
    vis2_exec: 'Kecepatan Eksekusi',
    vis2_execVal: 'Milidetik',
    vis2_auto: 'Tingkat Otomatisasi',
    vis2_compound: 'Loop Compound',
    vis2_compoundVal: 'Terus-menerus',
    core_title: 'Proposisi Nilai Inti',
    core_desc: 'Melalui penetapan harga probabilitas otomatis dan mekanisme compound, PolyAi-Claw terus menangkap deviasi harga dengan menjaga kontrol risiko.',
    core_highlight: 'penetapan harga probabilitas otomatis dan mekanisme compound',
    core_item0: 'Penetapan Harga Otomatis',
    core_item1: 'Mekanisme Compound',
    core_item2: 'Jaminan Kontrol Risiko',
    core_item3: 'Tangkap Deviasi Terus-menerus',
  },
  profitFlywheel: {
    badge: 'Flywheel Pertumbuhan Finansial Berbasis AI',
    title1: 'PolyWin AI',
    title2: 'Model Flywheel Profit',
    desc: 'Pertumbuhan PolyWin tidak bergantung pada profit trading tunggal tetapi pada sistem compound berkelanjutan berbasis AI',
    descHighlight: 'sistem compound berkelanjutan berbasis AI',
    aiCore: 'AI Probability Engine',
    step1_title: 'Input Data Global',
    step1_sub: 'Global Data',
    step1_desc: 'AI terus memantau berita, perubahan politik, data ekonomi makro, sentimen sosial, order book pasar',
    step1_tech: '50+ Sumber Data',
    step1_techDetail: 'Fusi real-time multi-sumber',
    step2_title: 'Pemodelan Probabilitas AI',
    step2_sub: 'Probability Modeling',
    step2_desc: 'Menggunakan model probabilitas Bayes, model koreksi sentimen untuk menghitung probabilitas sejati',
    step2_tech: 'Model Bayes',
    step2_techDetail: 'Pembaruan probabilitas dinamis real-time',
    step3_title: 'Deteksi Deviasi Probabilitas',
    step3_sub: 'Probability Edge',
    step3_desc: 'Ketika probabilitas sejati AI > probabilitas implisit pasar, diidentifikasi sebagai EV Positive Opportunity',
    step3_tech: 'Deviasi EV >5%',
    step3_techDetail: 'Deteksi EV positif otomatis',
    step4_title: 'Eksekusi Trading Otomatis',
    step4_sub: 'Algorithmic Execution',
    step4_desc: 'Sistem secara otomatis menyelesaikan pembangunan posisi, lindung nilai, eksekusi order di chain Polygon',
    step4_tech: 'Kontrak Pintar',
    step4_techDetail: '<200ms eksekusi milidetik',
    step5_title: 'Profit Pasar Prediksi',
    step5_sub: 'Market Profit',
    step5_desc: 'Ketika hasil event dikonfirmasi, sistem mendapatkan keuntungan arbitrase',
    step5_tech: 'Polygon PoS',
    step5_techDetail: 'Likuidasi otomatis on-chain',
    step6_title: 'Pemulihan Modal',
    step6_sub: 'Capital Recycling',
    step6_desc: 'Sistem secara otomatis mengambil kembali modal profit ke pool dana',
    step6_tech: 'Penyelesaian USDC',
    step6_techDetail: 'Stablecoin tanpa rugi nilai tukar',
    step7_title: 'Pertumbuhan Compound',
    step7_sub: 'Compounding Capital',
    step7_desc: 'Setelah pool dana membesar, AI dapat berpartisipasi di pasar lebih besar',
    step7_tech: 'Compound Otomatis',
    step7_techDetail: 'Loop reinvestasi profit otomatis',
    step8_title: 'Skala Modal Lebih Besar',
    step8_sub: 'Larger Liquidity Pool',
    step8_desc: 'Skala modal lebih besar berarti kapasitas trading lebih tinggi dan keuntungan lebih stabil',
    step8_tech: 'Ekspansi Likuiditas',
    step8_techDetail: 'Semakin besar semakin unggul',
    sum0_label: 'Lapisan Data',
    sum0_tech: '50+ Stream Multi-sumber',
    sum0_detail: 'Pemodelan Bayes real-time',
    sum1_label: 'Lapisan Eksekusi',
    sum1_tech: 'Otomatisasi Kontrak Pintar',
    sum1_detail: 'Penyelesaian on-chain Polygon PoS',
    sum2_label: 'Lapisan Penyelesaian',
    sum2_tech: 'USDC Stablecoin',
    sum2_detail: 'Penyelesaian tanpa rugi nilai tukar',
    sum3_label: 'Lapisan Compound',
    sum3_tech: 'Reinvestasi Otomatis',
    sum3_detail: 'Loop ekspansi skala positif',
    key0_title: 'Loop Penguatan Diri',
    key0_desc: 'Setiap profit memperkuat kemampuan sistem, membentuk loop umpan balik positif untuk pertumbuhan eksponensial',
    key1_title: 'Pertumbuhan Berbasis AI',
    key1_desc: 'Pertumbuhan tidak bergantung pada referral, melainkan kemampuan arbitrase probabilitas AI itu sendiri',
    key2_title: 'Sistem Compound Berkelanjutan',
    key2_desc: 'Pemulihan dan reinvestasi profit otomatis membuat pool dana terus berkembang',
    formula_title: 'Rumus Pertumbuhan Flywheel',
    f0_label: 'Data AI',
    f1_label: 'Arbitrase',
    f2_label: 'Profit',
    f3_label: 'Compound',
    f4_label: 'Modal Lebih',
    f5_label: 'Arbitrase Lebih',
    connected: 'Terhubung · Live',
  },
  sysArch: {
    badge: 'Official Architecture',
    title1: 'PolyAi-Claw AI',
    title2: 'Arsitektur Sistem',
    desc: 'Sistem keputusan AI lengkap dari pengumpulan data hingga penyelesaian otomatis',
    coreBadge: 'Otak AI Inti',
    feat0_title: 'Struktur Sistem AI Lengkap',
    feat0_desc: 'Bukan strategi sederhana, melainkan sistem keputusan AI lengkap mencakup seluruh alur dari pengumpulan data hingga eksekusi otomatis',
    feat1_title: 'Kontrol Risiko Level Dana Quant',
    feat1_desc: 'Model kontrol risiko dana quant profesional termasuk kontrol eksposur, lindung korelasi, alokasi modal dinamis',
    feat2_title: 'Arsitektur yang Dapat Diskalakan',
    feat2_desc: 'Dapat diperluas ke multi-pasar, multi-chain, multi-strategi',
    dataflow_title: 'Alur Data',
  },
  tradingExample: {
    badge: 'Studi Kasus Nyata',
    title1: 'PolyAi-Claw BTC',
    title2: 'Strategi Arbitrase 5 Menit',
    desc: 'Sistem hanya melakukan 3 hal: Deteksi volatilitas abnormal → Penilaian probabilitas 60 detik terakhir → Trading di zona aman',
    s1_title: 'BTC Market Data',
    s1_sub: 'Pemantauan Pasar Real-time',
    s1_notice: 'Data sampel kondisi pemicu strategi',
    s1_price: 'Harga Saat Ini',
    s1_eg: 'Contoh',
    s1_priceVol: 'Volatilitas Harga',
    s1_vol: 'Volume',
    s1_depth: 'Kedalaman Order Book',
    s1_trigger: 'Pemicu: Volatilitas ≥ 100 USD',
    s1_met: 'Terpenuhi',
    s2_title: 'PolyAi-Claw Engine',
    s2_sub: 'Perhitungan Probabilitas AI',
    s2_marketImplied: 'Probabilitas Implisit Pasar',
    s2_aiTrue: 'Probabilitas Sejati AI',
    s2_yes: 'YES',
    s2_probDiff: 'Keunggulan Probabilitas',
    s2_safe: 'Memasuki Zona Trading Aman',
    s3_title: 'Auto Trade + Profit',
    s3_sub: 'Eksekusi Otomatis & Keuntungan',
    s3_exec: 'Eksekusi Trading',
    s3_buyYes: 'Beli YES',
    s3_buyPrice: 'Harga Masuk',
    s3_settlement: 'Penyelesaian Pasar Prediksi',
    s3_correct: 'Prediksi Benar',
    s3_profit: 'Keuntungan Per Trading',
    s3_avg: 'Tingkat Keuntungan Rata-rata',
    s3_recycle: 'Keuntungan Dikembalikan ke Pool',
    chart_title: 'Grafik Deviasi AI vs Pasar',
    chart_sub: 'Pelacakan real-time deviasi probabilitas Poly Ai Claw vs pasar',
    chart_live: 'Live Analysis',
    chart_curDev: 'Deviasi Saat Ini',
    chart_signal: 'Sinyal Arbitrase',
    chart_signalVal: 'Dipicu',
    chart_winRate: 'Prakiraan Win Rate',
    chart_bottom_implied: 'Probabilitas Implisit Pasar',
    chart_bottom_dev: 'Zona Deviasi Probabilitas',
    chart_bottom_dev_sub: 'Peluang arbitrase terpicu',
    chart_bottom_ai: 'Probabilitas Sejati AI',
    chart_bottom_ai_sub: 'Output Model Poly Ai Claw',
    chart_bottom_implied_sub: 'Berdasarkan harga pasar',
    chart_marketProb: 'Probabilitas Implisit Pasar',
    chart_aiProb: 'Probabilitas Sejati AI',
    chart_deviationArea: 'Zona Deviasi Arbitrase',
    maxDeviation: 'Deviasi Maksimum',
    deviation: 'Deviasi',
    flow_title: 'Alur Strategi Lengkap',
    flow0_title: 'Pantau Data BTC',
    flow0_desc: 'Harga/volume real-time',
    flow1_title: 'Deteksi Volatilitas',
    flow1_desc: '≥ 100 USD',
    flow2_title: 'Filter Waktu',
    flow2_desc: '60 detik terakhir',
    flow3_title: 'Penilaian Win Rate',
    flow3_desc: '≥ 60-70%',
    flow4_title: 'Eksekusi Otomatis',
    flow4_desc: 'Beli YES/NO',
    flow5_title: 'Penyelesaian Pasar',
    flow5_desc: '1 USDC',
    flow6_title: 'Keuntungan Compound',
    flow6_desc: '3%-10%',
    risk0_title: 'Struktur Kontrol Risiko',
    risk0_i0: 'Batas modal per event < 5%',
    risk0_i1: 'Diversifikasi multi-event',
    risk0_i2: 'Stop-loss dinamis AI',
    risk1_title: 'Strategi Waktu',
    risk1_i0: 'Eksekusi dalam 60 detik terakhir',
    risk1_i1: 'Hindari trading emosional',
    risk1_i2: 'Informasi lebih lengkap',
    risk2_title: 'Kinerja Historis',
    risk2_i0: 'Win rate historis 80%-90%',
    risk2_i1: 'Keuntungan rata-rata 3%-10%',
    risk2_i2: 'Model arbitrase stabil',
  },
  crossPlatform: {
    badge: 'Arbitrase Lintas Platform',
    title1: 'PolyAi CLaw',
    title2: 'Logika Arbitrase Pasar Prediksi Lintas Platform',
    desc: 'Menghubungkan Polymarket (Web3) dan Kalshi (Fiat), menangkap deviasi harga, smart matching + eksekusi ultra-cepat',
    polymarket: 'Polymarket',
    kalshi: 'Kalshi',
    web3: 'Web3',
    fiat: 'Fiat',
    claw: 'CLaw',
    matched: '✓ Dicocokkan',
    matching: 'Mencocokkan...',
    sec1_badge: '01',
    sec1_accuracy: 'Akurasi 99%+',
    sec1_title: 'Pencocokan Pasar Cerdas',
    sec1_desc: 'Event di kedua platform secara otomatis diikat oleh AI semantik',
    sec2_badge: '02',
    sec2_ms: 'Eksekusi Milidetik',
    sec2_title: 'Integrasi Terpadu & Trading Ultra-cepat',
    sec2_desc: 'API/SDK terpadu menghubungkan multi-platform, penempatan order milidetik sinkron',
    connected: 'Terhubung · Live',
    latency: 'Latensi Order',
    dailyEvents: 'Event Dicocokkan Harian',
    successRate: 'Tingkat Keberhasilan Eksekusi',
    platforms: 'Platform Tersinkronisasi',
    sec3_badge: '03',
    sec3_analytics: 'Live Analytics',
    sec3_title: 'Visualisasi Data Arbitrase',
    sec3_desc: 'Deviasi harga real-time, keuntungan arbitrase, dan tren pertumbuhan',
    priceDeviation: 'Distribusi Deviasi Harga',
    volumeTitle: 'Volume Bulanan (K USDC)',
    h1Volume: 'Volume Kumulatif H1 (USDC)',
    arbIndicators: 'Metrik Keunggulan Arbitrase',
    arbSuccess: 'Tingkat Keberhasilan Spread Arbitrase',
    semanticAccuracy: 'Akurasi Pencocokan Semantik',
    liquidity: 'Likuiditas Lintas Platform',
    hedgeCoverage: 'Tingkat Cakupan Lindung',
  },
  mathAlgo: {
    badge: 'Algoritma Matematika Lanjutan yang Presisi',
    title1: 'Arbitrase Polymarket Bukan',
    title2: 'Masalah Matematika Sederhana',
    quote: 'Sementara Anda masih menghitung secara manual, sistem quant sudah melakukan sesuatu yang sama sekali berbeda.',
    quoteHighlight1: 'menghitung secara manual',
    quoteHighlight2: 'sesuatu yang sama sekali berbeda',
    ch0_title: 'Apa Itu Arbitrase? Mengapa Polymarket Punya Banyak?',
    ch0_tag: 'Inefisiensi Pasar',
    ch1_title: 'Arbitrase Lintas Pasar: Ketergantungan Logis',
    ch1_tag: 'Matematika Kombinatorial',
    ch2_title: 'Bregman Projection: Menghitung Ukuran Arbitrase Optimal',
    ch2_tag: 'Optimasi Cembung',
    pipeline_title: 'Sistem Arbitrase Polymarket — Arsitektur Lengkap',
    layer0: 'Lapisan 1: Pengumpulan Data',
    layer1: 'Lapisan 2: Deteksi Ketergantungan',
    layer2: 'Lapisan 3: Mesin Optimasi 3 Tingkat',
    layer3: 'Lapisan 4: Eksekusi & Manajemen Posisi',
    annualProfit: 'Total Profit Tahunan yang Diekstrak: $39,688,585',
    venn_title: 'Ketergantungan Logis: P(Menang 5%) ⊆ P(Menang)',
    contradiction: 'Kontradiksi! P(himpunan bagian) > P(himpunan induk) → Sinyal arbitrase dipicu',
    contradiction_sub: '0.55 > 0.48 → Kontradiksi logis → Peluang arbitrase',
    combinations: 'Kombinasi Pasar',
    brutal: 'Enumerasi brute-force tidak mungkin',
    integerConstraints: 'Batasan Pemrograman Integer',
    replaces: 'Menggantikan 16.384 enumerasi',
    bregman_title: 'KL Divergence vs Jarak Euclidean',
    coreData: 'Data Inti',
    pipeline4: 'Pipeline 4 Lapisan Sistem',
    annualReturn: 'Profit Tahunan ≈ $39,7 Juta',
    whyNotEnough_title: 'Mengapa "Jumlah Harga = $1" Tidak Cukup?',
    singleMarket: 'Pasar Tunggal — Terlihat Normal',
    crossMarket: 'Lintas Pasar — Ledakan Eksponensial',
  },
  mathProfit: {
    ch3_title: 'Algoritma Frank-Wolfe: Mendekati Jawaban Langkah demi Langkah',
    ch3_tag: 'Algoritma Iteratif',
    ch3_chapter: 'Bab 04',
    execTitle: 'Risiko Eksekusi Non-atomik',
    profitStructure: 'Struktur Profit (Apr 2024 – Apr 2025)',
    totalProfit: 'Total: $39,688,585',
    top10: 'TOP 10 mengambil 20,5%',
    kellyFormula: 'Rumus Posisi Kelly yang Dimodifikasi',
    preTrade: '4 Titik Periksa Pra-Trading',
    gate0: 'Likuiditas cukup?',
    gate1: 'Slippage dapat diterima?',
    gate2: 'Masih menguntungkan setelah slippage?',
    gate3: 'Profit > $0,05 → Eksekusi',
  },
  safuFund: {
    badge: 'Jaminan Keamanan Aset',
    title: 'Dana SAFU Polywin',
    titleHighlight: 'Dana SAFU',
    desc: 'Cadangan terkunci on-chain, transparan dan dapat diverifikasi secara real-time — aset Anda, kami lindungi',
    reserveLabel: 'Total Reserve · USDC · Ethereum Mainnet',
    verified: 'Terverifikasi On-chain',
    mainDesc: 'Tim Polywin telah mengunci 10 juta USDC sebagai dana cadangan keamanan SAFU di Ethereum mainnet.',
    mainDescHighlight: '10 juta USDC',
    contractLabel: 'Alamat Kontrak',
    etherscanBtn: 'Verifikasi di Etherscan',
    stat0_label: 'Ukuran Cadangan',
    stat0_sub: 'USDC',
    stat1_label: 'Tingkat Kunci On-chain',
    stat1_sub: 'On-Chain',
    stat2_label: 'Dapat Diverifikasi',
    stat2_sub: 'Real-time',
    stat3_label: 'Kompensasi Historis',
    stat3_val: '$0',
    stat3_sub: 'Catatan Tanpa Kerugian',
    f0_title: 'Terkunci On-chain',
    f0_desc: '100% dana terkunci dalam kontrak pintar Ethereum mainnet',
    f1_title: 'Sepenuhnya Transparan',
    f1_desc: 'Siapapun dapat melihat saldo dan riwayat transaksi melalui Etherscan secara real-time',
    f2_title: 'Kompensasi Cepat',
    f2_desc: 'Proses kompensasi dimulai dalam 72 jam setelah insiden dikonfirmasi',
    f3_title: 'Audit Independen',
    f3_desc: 'Lembaga keamanan pihak ketiga secara berkala mengaudit kode kontrak',
  },
  cta: {
    badge: 'Mulai Sekarang',
    title1: 'Mulai Menggunakan',
    title2: 'Poly Ai Claw',
    title3: 'Intelligence Engine',
    desc: 'Tidak perlu pengalaman coding — konfigurasi strategi AI dalam 3 menit',
    btn: 'Aktifkan AI-Claw',
    trust0: 'Mitra Resmi Polygon',
    trust1: 'Bersertifikat Lembaga Audit',
    trust2: '10.000+ Pengguna Aktif',
    trust3: '$50 Juta+ Volume Kumulatif',
  },
  footer: {
    tagline: 'Poly Ai Claw Intelligence Engine',
    product: 'Produk',
    resources: 'Sumber Daya',
    social: 'Media Sosial',
    link0: 'Algoritma Poly AI-Claw',
    link1: 'Sistem Kontrol Risiko',
    link2: 'Data API',
    link3: 'Dokumentasi Pengembang',
    res0: 'Tutorial',
    res1: 'Kasus Strategi',
    res2: 'Whitepaper',
    res3: 'Forum Komunitas',
    copyright: '© 2026 PolyWin. All rights reserved.',
    privacy: 'Kebijakan Privasi',
    terms: 'Ketentuan Layanan',
  },
};
